/* PC Card Quick Add — robust handler */
(function () {
  'use strict';

  function handleQuickAdd(btn) {
    if (!btn) return;
    if (btn.getAttribute('data-busy') === '1') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    /* Mark busy */
    btn.setAttribute('data-busy', '1');
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.classList.remove('is-loading');

      if (data.status && data.status >= 400) {
        /* Error */
        btn.removeAttribute('data-busy');
        var msg = data.description || 'Could not add to cart';
        btn.querySelector('.pc-qa__label') && (btn.querySelector('.pc-qa__label').textContent = msg);
        setTimeout(function () {
          btn.querySelector('.pc-qa__label') && (btn.querySelector('.pc-qa__label').textContent = 'Add to Cart');
        }, 2000);
        return;
      }

      /* Success */
      btn.classList.add('is-added');

      /* Update cart count */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count],[data-cart-drawer-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (window.DecorWalayCart && window.DecorWalayCart.refresh) {
            window.DecorWalayCart.refresh();
          }
        });

      /* Reset after 2s */
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.removeAttribute('data-busy');
      }, 2000);
    })
    .catch(function (err) {
      console.error('Quick add error:', err);
      btn.classList.remove('is-loading');
      btn.removeAttribute('data-busy');
    });
  }

  function handleBuyNow(btn) {
    if (!btn || btn.getAttribute('data-busy') === '1') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('data-busy', '1');
    btn.classList.add('is-loading');
    btn.disabled = true;

    var label = btn.querySelector('.pc-buy-label');
    var original = label ? label.textContent : 'Buy Now';
    if (label) label.textContent = 'Loading…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status && data.status >= 400) {
        throw new Error(data.description || 'Could not buy now');
      }
      window.location.href = '/checkout';
    })
    .catch(function () {
      if (label) label.textContent = original;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('data-busy');
    });
  }

  /* Use capture phase so hover state doesn't swallow the event */
  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('[data-pc-buy-now]');
    if (buyNow) {
      e.preventDefault();
      e.stopPropagation();
      handleBuyNow(buyNow);
      return;
    }

    var btn = e.target.closest('[data-pc-quick-add]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      handleQuickAdd(btn);
    }
  }, true);

  /* Also attach directly after DOM ready in case capture doesn't fire */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pc-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleQuickAdd(btn);
      });
    });
  });

})();
